export const TestimonialsLoaded = data => ({
    type: 'TESTIMONIALS_DATA_LOADED',
    payload : data
})